import styled from 'styled-components';
import { CarouselWrapper } from '../../../ui/components/CustomCarousel/style';

export const FiltersWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
`;

export const SelectWrapper = styled.div`
  width: 230px;
`;

export const NewsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-bottom: 60px;
`;

export const NewsCarouselWrapper = styled(CarouselWrapper)`
  padding: 0 48px 32px;
  max-width: min(var(--full-width), 1440px);
  margin: auto;
  @media ${(props) => props.theme.device.tablet} {
    padding-left: 24px;
    padding-right: 24px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding-left: 0;
    padding-right: 0;
  }

  .slick-slide {
    @media ${(props) => props.theme.device.tablet} {
      margin: 0 8px;
    }
  }
`;
